import { TmApiNotFoundError } from '@/core/error/transport/tmApiNotFoundError'

export class TmApiTaskChecklistItemNotFoundError extends TmApiNotFoundError {
  public name = 'TmApiTaskChecklistItemNotFoundError'
}
